import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n
  .use(Backend) // Load translations via HTTP
  .use(initReactI18next) // Connects i18n to React
  .init({
    debug: false,
    fallbackLng: 'en', // Fallback language
    lng: 'en', // Default language
    ns: ['home'], // Namespaces to load
    defaultNS: 'home', // Default namespace
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // Path to translation files
    },
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
  });

export default i18n;
